import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { captureException } from "./lib/error-logger";

// Bridge unhandled promise rejections into the logger (and keep console log).
window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  console.error("[unhandledrejection]", reason);
  captureException(reason instanceof Error ? reason : new Error(String(reason)), {
    kind: "unhandledrejection",
  });
});

// Also catch classic uncaught errors that miss React's boundary.
window.addEventListener("error", (event) => {
  if (!event.error) return; // resource load errors have no `error` prop
  captureException(event.error, { kind: "window.error" });
});

createRoot(document.getElementById("root")!).render(<App />);
